export default {
  error_occurred:
    'Ocurri\u00f3 un error. Por favor, int\u00e9ntelo de nuevo m\u00e1s tarde.',
  oops: 'Ups!',
  okay: 'OK',
  title_signout: '\u00bfCerrar sesi\u00f3n?',
  confirm_signout: 'Cerrar\u00e1 sesi\u00f3n de los siguientes equipos',
};
